const varoBankDisclosureUrl = `https://prod-cdn.varomoney.com/agreements/b4d55761-9ff2-43bd-b82e-0772e68542c1.pdf`;

export default varoBankDisclosureUrl;
